var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-button",class:{ 'has-circle-bg': _vm.hasCircle, disabled: _vm.disabled }},[_c('SIcon',{attrs:{"name":"close-x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }